import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import {
  formatQueueAge,
  METHOD_CHIP_SX,
  methodLabel,
} from "./queueModel";

function statusLabel(status) {
  if (status === "InProgress") return "In Progress";
  return status || "Open";
}

function MethodChips(props) {
  var fromMethod = props.fromMethod;
  var toMethod = props.toMethod;
  var method = props.method;
  if (fromMethod && toMethod) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
        <Chip size="small" label={methodLabel(fromMethod)} sx={METHOD_CHIP_SX[fromMethod]} />
        <Typography component="span" sx={{ fontSize: 11, color: "#64748b" }}>
          →
        </Typography>
        <Chip
          size="small"
          label={methodLabel(toMethod)}
          sx={METHOD_CHIP_SX[toMethod] || METHOD_CHIP_SX.other}
        />
      </Box>
    );
  }
  if (method) {
    return (
      <Chip
        size="small"
        label={methodLabel(method)}
        sx={METHOD_CHIP_SX[method] || METHOD_CHIP_SX.other}
      />
    );
  }
  return null;
}

export function QueueWorkItemRow(props) {
  var item = props.item;
  var onOpen = props.onOpen;
  var dense = props.dense;
  var details = [];
  if (item.patientName) details.push(item.patientName);
  if (item.stockCode) details.push(item.stockCode);
  if (item.pickupCode) details.push("PU " + item.pickupCode);
  if (item.bagNumber) details.push("Bag " + item.bagNumber);
  if (item.fromLocation && item.toLocation) {
    details.push(item.fromLocation + " → " + item.toLocation);
  } else if (item.locationName) {
    details.push(item.locationName);
  }
  details.push(formatQueueAge(item.ageMs));

  return (
    <Box
      role="button"
      tabIndex={0}
      data-testid={"queue-item-" + item.id}
      onClick={function () { onOpen(item); }}
      onKeyDown={function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen(item);
        }
      }}
      sx={{
        border: item.urgent ? "1px solid #fecaca" : "1px solid #e2e8f0",
        borderLeft: item.urgent ? "4px solid #dc2626" : "4px solid transparent",
        borderRadius: "10px",
        p: dense ? "8px 10px" : "10px 12px",
        backgroundColor: item.urgent ? "#fef2f2" : "#fff",
        cursor: "pointer",
        "&:hover": { borderColor: "#0a5d66" },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, fontSize: dense ? "0.82rem" : "0.9rem", color: "#0f172a" }}>
          {item.title || "Open task"}
        </Typography>
        {item.urgent ? (
          <Chip size="small" label="Urgent" sx={{ backgroundColor: "#dc2626", color: "#fff", fontWeight: 700, height: 22 }} />
        ) : (
          <Chip
            size="small"
            label={statusLabel(item.workflowStatus)}
            sx={{ fontWeight: 600, height: 22 }}
          />
        )}
      </Box>
      <MethodChips fromMethod={item.fromMethod} toMethod={item.toMethod} method={item.method} />
      <Typography sx={{ color: "#64748b", fontSize: "0.75rem", mt: 0.5 }}>
        {details.join(" · ")}
      </Typography>
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/workflowQueue/QueueWorkItemRow.js